import "./index.scss";

export const SellHeader = () => (
  <div className="sell-header">
    <h1>Exchange Gift Cards for Cash</h1>
    <p>Earn cash for unwanted cards and store credits.</p>
  </div>
);
